function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 31,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00999a"
    },
    fillRule: "evenodd",
    d: "M27.428 3.539h3.45v7.096l-3.437-2.914-.013-4.182zm3.776 12.05L17.788 3.568 3.479 15.661c-2.394 2.025-3.492 0-3.492 0L17.788-.002l17.226 15.591s-1.039 1.996-3.81 0zm-1.345 1.082v13.322s.046.976-.926.976h-8.642l.016-7.206s.083-1.19-1.284-1.19h-3.664c-1.157 0-1.034 1.19-1.034 1.19l-.013 7.228s-7.875.01-8.829.01c-.765 0-.734-.78-.734-.78v-13.55L17.68 5.844l12.179 10.827z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHome);
export default __webpack_public_path__ + "static/media/ico-home.b2df0c4cf2d1a8de66fa09ae0db524d1.svg";
export { ForwardRef as ReactComponent };